// Add your custom JS here.
const stringMonths = [
  "január",
  "február",
  "március",
  "április",
  "május",
  "június",
  "július",
  "augusztus",
  "szeptember",
  "október",
  "november",
  "december",
];

let localToday = new Date();
let localYear = new Date().getFullYear();
let localDay = 1;
let localMonth = 1;
let localStartDayOfMonth = 1;
let localStringMonth = "január";
let localEndDayOfMonth = 1;
let rows = 0;
let monthAsString = "";

const today = new Date();
const day = today.getDate();
const month = today.getMonth();
today.setDate(1);
const startDayOfMonth = today.getDay();
today.setMonth(today.getMonth() + 1);
today.setDate(0);
const endDayOfMonth = today.getDate();
localToday = day;
localMonth = month;
localStringMonth = stringMonths[month];
localStartDayOfMonth = startDayOfMonth === 0 ? 7 : startDayOfMonth;
localEndDayOfMonth = endDayOfMonth;
if (
  (endDayOfMonth === 30 && startDayOfMonth === 0) ||
  (endDayOfMonth === 31 && startDayOfMonth === 0) ||
  (endDayOfMonth === 31 && startDayOfMonth === 6)
) {
  rows = 6;
} else if (endDayOfMonth === 28 && startDayOfMonth === 1) {
  rows = 4;
} else {
  rows = 5;
}
let k = 1;
let start = localStartDayOfMonth;
let days = 7;
for (let i = 0; i < rows; i++) {
  monthAsString += `<ul>`;
  for (let j = 0; j < days; j++) {
    if (j >= start - 1) {
      if (k < endDayOfMonth + 1) {
        if (k === localToday) {
          monthAsString += `<li class="today"><b>${k++}</b></li>`;
        } else {
          monthAsString += `<li>${k++}</li>`;
        }
      } else {
        monthAsString += `<li></li>`;
      }
    } else {
      monthAsString += `<li></li>`;
    }
  }
  start = 0;
  monthAsString += `</ul>`;
}

document.getElementById('calendar-title').innerHTML = `${localYear}. ${localStringMonth}`
document.getElementById('calendar-body').innerHTML = `${monthAsString}`